// Environment variables with fallbacks
const PROD_API_URL = 'https://api.senaehr.com';
const LOCAL_API_URL = 'https://localhost:5236'; // Adjust port as needed

export const isLocalBrowser = () => {
    if (typeof window === 'undefined') {
        return process.env.NODE_ENV === 'development';
    }

    const { hostname } = window.location;
    return (
        hostname === 'localhost' ||
        hostname === '[::1]' ||
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(hostname)
    );
};

const normalizeMessageHubUrl = (url) => {
    if (!url) return url;
    if (/\/api\/messageHub(\?.*)?$/.test(url)) return url;
    return url.replace(/\/messageHub(\?.*)?$/, '/api/messageHub$1');
};

const config = {
    // API Configuration
    api: {
        // Use production URLs by default, override with .env for local development
        baseUrl: process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'development' ? LOCAL_API_URL : PROD_API_URL),
        version: process.env.REACT_APP_API_VERSION || '/api',
        timeout: process.env.REACT_APP_API_TIMEOUT || 30000,
        rootUrl: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? LOCAL_API_URL : PROD_API_URL),
        authUrl: process.env.REACT_APP_AUTH_BASE_URL || `${process.env.NODE_ENV === 'development' ? LOCAL_API_URL : PROD_API_URL}/api/auth`,
        messageHubUrl: (() => {
            const envUrl = process.env.REACT_APP_MESSAGE_HUB_URL;
            const defaultUrl = `${process.env.NODE_ENV === 'development' ? LOCAL_API_URL : PROD_API_URL}/api/messageHub`;
            const finalUrl = normalizeMessageHubUrl(envUrl || defaultUrl);
            return finalUrl;
        })(),
        
        // Utility functions for URL construction
        get url() {
            return `${this.baseUrl}${this.version}`;
        },
        getEndpointUrl(endpoint) {
            return `${this.url}${endpoint}`;
        },
        getAuthEndpointUrl(endpoint) {
            return `${this.authUrl}${endpoint}`;
        }
    },
    
    // Environment
    env: process.env.REACT_APP_ENV || 'development',

    get isSubscriptionGatingEnabled() {
        return this.env === 'production' && process.env.NODE_ENV === 'production' && !isLocalBrowser();
    },
    
    // Application settings
    app: {
        version: '1.0.0',
        dateFormat: 'MMMM dd, yyyy',
        timeFormat: 'h:mm a'
    },
    
    // Feature flags
    features: {
        enableDebugLogging: process.env.REACT_APP_ENABLE_DEBUG_LOGGING === 'true' || false
    }
};

// Log the current configuration
if (config.env === 'development') {
    console.log('Running in development mode');
    console.log('Config:', {
        baseUrl: config.api.baseUrl,
        url: config.api.url,
        authUrl: config.api.authUrl,
        messageHubUrl: config.api.messageHubUrl
    });
}

export default config; 
